export default {
  UNBANNED: { value: 0,  label: "正常" },
  BANNED: { value: 1,  label: "下架" },
}
